<template>
  <div>
    <PageHeader>
      <template slot="header-logo_image">
        <router-link to="/">
          <img src="@/assets/gemnote_logo_and_text.svg" alt="" />
        </router-link>
      </template>
    </PageHeader>

    <Maintenance>
      <template slot="display_image">
        <img src="../assets/maintenanceicon.svg" class="mx-auto" />
      </template>

      <template slot="status_text">
        <h1 class="status--text">
          We’ll be back soon!
        </h1>
        <p>
          This page is down for scheduled maintainence. Please check back in a
          little while.
        </p>
        <p>
          For the best merch and swag, please visit
          <a
            href="https://www.gemnote.com/"
            target="_blank"
            rel="noopener noreferrer"
            ><strong>Gemnote</strong></a
          >.
        </p>
      </template>
    </Maintenance>
  </div>
</template>

<script>
import Maintenance from '../components/Maintenance.vue'
import PageHeader from '../components/Universal/Header.vue'
import { layouts } from '@/helpers'

export default {
  name: 'maintanence',
  components: { PageHeader, Maintenance },
  created() {
    this.$store.dispatch('layout/setPageLayout', layouts.DEFAULT_LAYOUT)
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';
a {
  text-decoration: none;
}

header {
  border-bottom: solid 1px;
  height: 80px;
  display: flex;
  align-items: center;

  .logo {
    a {
      height: inherit;
      img {
        height: inherit;
        object-fit: contain;
      }
    }
  }
}

.notfound {
  height: 100%;
  width: 100%;
  margin-top: 5rem;

  img {
    // width: 17%;
    padding-bottom: 1rem;
    margin: auto;
  }

  h1 {
    padding-bottom: 1rem;
    text-transform: uppercase;
    font-family: 'Editorial New';
    font-size: 2rem;
    font-weight: normal;
    text-align: center;
  }
  p {
    font-weight: 500;
    font-size: 0.813rem;
  }
}

@media (min-width: 768px) {
  header {
    height: 120px;
  }
}
</style>
